import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppComponent } from './app.component';

import { NgsRevealModule } from 'ngx-scrollreveal';
import { SwiperModule } from 'ngx-swiper-wrapper';
import { SWIPER_CONFIG } from 'ngx-swiper-wrapper';
import { NgxPageScrollCoreModule } from 'ngx-page-scroll-core';
import { NgxPageScrollModule } from 'ngx-page-scroll';
import { SwiperConfigInterface } from 'ngx-swiper-wrapper';
import { NavbarComponent } from './navbar/navbar.component';
import { ExtraOptions, RouterModule, Routes } from '@angular/router';

const DEFAULT_SWIPER_CONFIG: SwiperConfigInterface = {
    direction: 'horizontal',
    slidesPerView: 'auto'
};

@NgModule({
    declarations: [
        AppComponent,
        NavbarComponent,
    ],
    imports: [
        BrowserModule,
        SwiperModule,
        NgsRevealModule,
        NgxPageScrollCoreModule.forRoot({ duration: 800 }),
        NgxPageScrollModule,
        RouterModule.forRoot([])
    ],
    providers: [
        {
            provide: SWIPER_CONFIG,
            useValue: DEFAULT_SWIPER_CONFIG
        }
    ],
    bootstrap: [AppComponent]
})
export class AppModule { }
